/**
 * A global namespace for `change` event.
 */
const changeEvent = "change";
export default changeEvent;
